import classNames from 'classnames'
import { JSX, useEffect } from 'react'

import styles from 'core-components/sitebuilder/common/NotificationPageLayout.module.scss'

interface INotificationPageLayout {
  headerText: string
  headerDescriptionText: string
  description: string | JSX.Element
  footerContent?: () => JSX.Element
  imageLink?: string
  footerTemplate?: (className: string) => JSX.Element
  documentTitle?: string
  backgroundColor?: 'white' | 'transparent'
}

export const NotificationPageLayout = ({
  headerText,
  headerDescriptionText,
  description,
  imageLink,
  footerContent,
  documentTitle,
  backgroundColor,
  footerTemplate,
}: INotificationPageLayout) => {
  useEffect(() => {
    if (documentTitle) {
      document.title = documentTitle
    }
  }, [documentTitle])

  return (
    <div className={classNames(styles.root, styles[`background-${backgroundColor}`])}>
      <div className={styles.text}>
        <div className={styles.headerText}>{headerText}</div>
        <div className={styles.notFound}>{headerDescriptionText}</div>
        <div className={styles.notification}>{description}</div>
        {footerContent ? footerContent() : null}
      </div>
      {imageLink ? <img className={styles.image} src={imageLink} alt="" /> : null}
      {footerTemplate ? footerTemplate(styles.image) : null}
    </div>
  )
}
